import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SafeUrl } from '@angular/platform-browser';
import { SkeletonBlockComponent } from '@custom-components/general/skeleton/skeleton-block/skeleton-block.component';
import { UploadPhotoDialogComponent } from '@custom-components/overlay/upload-photo-dialog/upload-photo-dialog.component';
import { LANGUAGES } from '@core/constants';
import { UserProfile } from '@core/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xemex-general-info',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatRippleModule,
    SkeletonBlockComponent,
    TranslateModule,
  ],
  templateUrl: './general-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './general-info.component.scss',
})
export class GeneralInfoComponent {
  isLoading = input<boolean>(false);
  userProfile = input<UserProfile>();
  userAvatar = input<SafeUrl>();
  isLoadingAvatar = input<boolean>();
  uploadAvatar = output<BlobPart>();
  generalInfoForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl({ value: '', disabled: true }, [Validators.email]),
    phone: new FormControl(''),
    language: new FormControl(''),
  });

  LANGUAGES = LANGUAGES;
  croppedImage: SafeUrl | undefined;

  get firstNameControl(): FormControl {
    return this.generalInfoForm.controls.firstName as FormControl;
  }

  get lastNameControl(): FormControl {
    return this.generalInfoForm.controls.lastName as FormControl;
  }

  get emailControl(): FormControl {
    return this.generalInfoForm.controls.email as FormControl;
  }

  get phoneControl(): FormControl {
    return this.generalInfoForm.controls.phone as FormControl;
  }

  get languageControl(): FormControl {
    return this.generalInfoForm.controls.language as FormControl;
  }

  get formValue() {
    return this.generalInfoForm.value;
  }

  constructor(private readonly dialog: MatDialog) {
    effect(() => {
      this.croppedImage = this.userAvatar();
      this.setValueGeneralInfoForm();
    });
  }

  setValueGeneralInfoForm() {
    if (this.userProfile()) {
      this.generalInfoForm.setValue({
        firstName: this.userProfile()?.firstName ?? '',
        lastName: this.userProfile()?.lastName ?? '',
        email: this.userProfile()?.email ?? '',
        phone: this.userProfile()?.phone ?? '',
        language: this.userProfile()?.language ?? '',
        // role: '',
      });
    }
  }

  onUploadProfilePhoto() {
    this.dialog
      .open(UploadPhotoDialogComponent, {
        width: '640px',
        height: '456px',
        maxWidth: '640px',
        data: {},
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.croppedImage = result.croppedImage;
          this.uploadAvatar.emit(result.imageBlob);
        }
      });
  }
}
